export const en = {
  severity: 'SEVERITY:'
};

export type Translations = typeof en;
